import React from 'react'
import WOW from 'react-wow'
import {connectMenu} from 'react-instantsearch-dom'

import * as S from './styled'

const Menu = ({items, refine, title}) => {
    const refinedItems = items.map(item => item.isRefined)
    const hasRefined = refinedItems.includes(true);
    
    return ((
        <WOW animation="fadeInUp">
            <S.MenuSearchWrapper>
                <S.MenuSearchTitle>
                    {title || 'Categorias'}
                </S.MenuSearchTitle>

                <S.MenuSearchItems>
                    <S.MenuSearchItem key={`*`} active={!hasRefined}>
                        <a
                            href="#"
                            onClick={event => {
                            event.preventDefault();
                            refine('');
                        }}>
                            {`Todos`}
                        </a>
                    </S.MenuSearchItem>

                    {items.map(item => (
                        <S.MenuSearchItem key={item.value} active={item.isRefined}>
                            <a
                                href="#"
                                onClick={event => {
                                event.preventDefault();
                                refine(item.value);
                            }}>
                                {item.label}
                            </a>
                        </S.MenuSearchItem>
                    ))}
                </S.MenuSearchItems>
            </S.MenuSearchWrapper>
        </WOW>
    ))
};

export default connectMenu(Menu);